import { filterOutrightsMarkets } from "../filterOutrightsMarkets";
import { filterOutrightSelections } from "../filterOutrightSelections";
import { sortSelectionsByOdd } from "../sortSelectionsByOdd";
import { observable } from "mobx";
export var prepareOutrightMarkets = function (markets, events) {
    var outrightMarkets = filterOutrightsMarkets(true, markets, events);
    return outrightMarkets.map(function (market) {
        market.selections = observable.array(filterOutrightSelections(market.selections).sort(sortSelectionsByOdd));
        return market;
    });
};
//# sourceMappingURL=prepareOutrightMarkets.js.map